export default class TaskDocumentation {

  id = null;
  documentType = 'TASK';
  fileType = null;
  size = '';
  fileName = '';
  md5 = '';
  startDate = null;
  assignedTo = null;
  customer = null;
  task = null;
  faultReport = false;
  note = '';
  supplier = '';
  isOrderDocumentation = false;
  supplierId = null;

  constructor() {
  }
}